import { render } from "./KsModal.vue?vue&type=template&id=150d488a"
import script from "./KsModal.vue?vue&type=script&lang=js"
export * from "./KsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__